import { render, staticRenderFns } from "./newspecialindex.vue?vue&type=template&id=4697843c&scoped=true"
import script from "./newspecialindex.vue?vue&type=script&lang=js"
export * from "./newspecialindex.vue?vue&type=script&lang=js"
import style0 from "./newspecialindex.vue?vue&type=style&index=0&id=4697843c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697843c",
  null
  
)

export default component.exports